<template>
  <router-view/>
</template>

<script>
  import { store } from "@/store";
  import { provideI18n } from "@/i18nPlugin";
  import zh_CN from '@/i18n/zh_CN'
  import en_US from '@/i18n/en_US'
 
  export default {
    setup() {
      let locale = 'zh_CN'
      if (localStorage.getItem('setLang')) {
        locale = localStorage.getItem('setLang');
        store.commit('setLang', locale);
      } else {
        store.commit('setLang', locale);
      }
      provideI18n({
        locale: locale,
        messages: {
          'zh_CN': zh_CN,
          'en_US': en_US
        }
      })
    }
  };
</script>
<style>
#app {
  font-family: pingfang SC, helvetica neue, arial, hiragino sans gb, microsoft yahei ui, microsoft yahei, simsun, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
